export const queryKeys = {
  WORKLOADS: 'workloads',
}
